import React from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import FormikAsyncSelect from '../../components/formik/FormikAsyncSelect';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { TableHeader } from '../../components/Table/TableHeader';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import { toast } from 'react-toastify';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { string, object, array } from 'yup';
import { createJobWork } from '../../app/api/jobWork';
import { ClipLoader } from 'react-spinners';

const CreateJobWork = () => {
    const formik = useFormik({
        initialValues: {
            vendor: '',
            vendorName: '',
            date: moment().valueOf(),
            notes: '',
            cuttingCard: '',
            jobDetails: [],
        },
        validationSchema: object({
            vendor: string().required(),
            vendorName: string().required(),
            date: string().required(),
            notes: string().optional(),
            cuttingCard: string().optional(),
            jobDetails: array().of(
                object({
                    cuttingCardRef: string().required(),
                    cuttingCardNumber: string().required(),
                    PCS: string().required(),
                    cut: string().required(),
                    meter: string().required(),
                    sendQuantity: string().required(),
                })
            ),
        }),
        onSubmit: async (values) => {
            try {
                console.log(values);
                const jobWorkResp = await createJobWork(values);
                console.log(jobWorkResp.data);
                toast.success('job work created');
                formik.resetForm();
            } catch (error) {
                console.log(error);
                toast.error('failed to create Data');
            }
        },
    });
    return (
        <PageWithCard>
            <div className="p-4">
                <form onSubmit={formik.handleSubmit}>
                    <div className="grid grid-cols-3 gap-4 mb-4">
                        <FormikInputDateGroup
                            formik={formik}
                            label="Date"
                            name={'date'}
                            required
                        />
                        <FormikAsyncSelect
                            name="vendor"
                            required
                            label="Vendor"
                            formik={formik}
                            getOptions={async (value) => {
                                const data = {
                                    search: value,
                                    contact_type: 'vendor',
                                };
                                const string = QueryString.stringify(data);
                                const contactsResp =
                                    await authAxiosInstance.get(
                                        `purchase-orders/contacts?${string}`
                                    );
                                const contacts =
                                    contactsResp.data.data.contacts;
                                console.log(contacts, 'cts');
                                const serverResp = contacts.map((ele) => ({
                                    label: `${ele.contact_name}/${ele.gst_no}`,
                                    value: `${ele.contact_id}/${ele.contact_name}`,
                                }));
                                return serverResp;
                            }}
                            onChange={(option) => {
                                const id = option.value.split('/')[0];
                                const vendor_name = option.value.split('/')[1];
                                formik.setFieldValue('vendorName', vendor_name);
                                formik.setFieldValue('vendor', id);
                            }}
                        />
                        <FormikInputGroup
                            label="Notes"
                            name={'notes'}
                            formik={formik}
                        />
                    </div>
                    <div className="flex flex-col gap-4">
                        <FormikProvider value={formik}>
                            <FieldArray
                                name="jobDetails"
                                render={(arrayHelpers) => (
                                    <>
                                        <FormikAsyncSelect
                                            name="cuttingCard"
                                            required
                                            label="Cutting Card"
                                            formik={formik}
                                            getOptions={async (value) => {
                                                const data = {
                                                    search: value,
                                                    status: 'complete',
                                                };
                                                const string =
                                                    QueryString.stringify(data);
                                                const cuttingResp =
                                                    await authAxiosInstance.get(
                                                        `cuttingCard?${string}`
                                                    );
                                                const cuttingCards =
                                                    cuttingResp?.data?.data
                                                        ?.docs?.length > 0
                                                        ? cuttingResp?.data
                                                              ?.data?.docs
                                                        : [];
                                                const serverResp =
                                                    cuttingCards.map((ele) => ({
                                                        label: `${ele.cuttingCardNumber}`,
                                                        value: `${ele._id}`,
                                                    }));
                                                return serverResp;
                                            }}
                                            onChange={async (option) => {
                                                const searchPayload = {
                                                    _id: option.value,
                                                    populate: true,
                                                };
                                                const string =
                                                    QueryString.stringify(
                                                        searchPayload
                                                    );
                                                const cuttingResp =
                                                    await authAxiosInstance.get(
                                                        `/cuttingCard?${string}`
                                                    );
                                                const cuttingCard =
                                                    cuttingResp.data.data
                                                        .docs[0];
                                                const cuttingRefArray =
                                                    formik.values.jobDetails.map(
                                                        (ele) =>
                                                            ele.cuttingCardRef
                                                    );
                                                if (
                                                    cuttingRefArray.includes(
                                                        cuttingCard._id
                                                    )
                                                ) {
                                                    toast.error(
                                                        'Cutting card already selected'
                                                    );
                                                    return;
                                                }
                                                arrayHelpers.push({
                                                    cuttingCardRef:
                                                        cuttingCard._id,
                                                    cuttingCardNumber:
                                                        cuttingCard.cuttingCardNumber,
                                                    PCS: cuttingCard.remaining,
                                                    postToZoho:
                                                        cuttingCard.greyPoRef
                                                            .postToZoho,
                                                    cut: cuttingCard.cut,
                                                    meter: cuttingCard.millMeter,
                                                    sendQuantity:
                                                        cuttingCard.remaining,
                                                    sort: 0,
                                                    extra: 0,
                                                });
                                            }}
                                        />
                                        <table>
                                            <TableHeader
                                                headers={[
                                                    { name: 'Cutting Card#' },
                                                    { name: 'Remaining' },
                                                    { name: 'Cut' },
                                                    { name: 'Meter' },
                                                    { name: 'Send Quantity' },
                                                    { name: 'Sort' },
                                                    { name: 'Extra' },
                                                    { name: 'Post To Zoho' },
                                                    { name: 'Action' },
                                                ]}
                                            />
                                            <tbody>
                                                {formik.values.jobDetails.map(
                                                    (ele, i) => (
                                                        <tr>
                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.cuttingCardNumber`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.PCS`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                    readOnly
                                                                />
                                                            </td>

                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.cut`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.meter`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.sendQuantity`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.sort`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.extra`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                />
                                                            </td>
                                                            <td>
                                                                <FormikInputGroup
                                                                    name={`jobDetails.${i}.postToZoho`}
                                                                    formik={
                                                                        formik
                                                                    }
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <DangerButton
                                                                        type="button"
                                                                        onClick={() => {
                                                                            arrayHelpers.remove(
                                                                                i
                                                                            );
                                                                        }}
                                                                    >
                                                                        Remove
                                                                    </DangerButton>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </>
                                )}
                            />
                        </FormikProvider>
                    </div>
                    <div>
                        {formik.isSubmitting ? (
                            <ClipLoader />
                        ) : (
                            <PrimaryButton type="submit">Submit</PrimaryButton>
                        )}
                    </div>
                </form>
            </div>
        </PageWithCard>
    );
};

export default CreateJobWork;
